import { render, staticRenderFns } from "./orderInfoAddEdit.vue?vue&type=template&id=db2c1bce"
import script from "./orderInfoAddEdit.vue?vue&type=script&lang=js"
export * from "./orderInfoAddEdit.vue?vue&type=script&lang=js"
import style0 from "./orderInfoAddEdit.vue?vue&type=style&index=0&id=db2c1bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports